export default __webpack_public_path__ + "static/media/13.87791584.webp";